import { Star } from "lucide-react";

export default function RatingStars({ rating = 0, size = 12 }) {
  const full = Math.round(rating);
  return (
    <span className="inline-flex items-center gap-0.5 align-middle">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= full ? "fill-amber-400 text-amber-400" : "text-white/20"}
        />
      ))}
    </span>
  );
}
